import { Stat, StatGroup, StatHelpText, StatLabel, StatNumber } from '@chakra-ui/react'
import React from 'react'

const GroupDate = () => {
  return (

    <StatGroup>
      <Stat>
        <StatLabel>Filiais</StatLabel>
        <StatNumber>15</StatNumber>
        <StatHelpText>Total</StatHelpText>
      </Stat>
      <Stat>
        <StatLabel>Carros</StatLabel>
        <StatNumber>30</StatNumber>
        <StatHelpText>Total</StatHelpText>
      </Stat>
      <Stat>
        <StatLabel>Motoristas</StatLabel>
        <StatNumber>35</StatNumber>
        <StatHelpText>Total</StatHelpText>
      </Stat>
    </StatGroup>


  )
}

export default GroupDate
